export { FaqPageJsonLd, FAQ_PAGE_JSONLD_ID, default } from "./FaqPageJsonLd";
export type { FaqPageJsonLdProps } from "./FaqPageJsonLd";
